angular.module("vgresiduos").factory("externalSystemService", [
	"$http",
	function ($http) {
		"use strict";

		const _createClientExternalSystem = function (dto) {
			const req = {
				method: "post",
				data: dto,
				url:
					Vgr.constants.coreHostUrl +
					Vgr.resources.core.externalSystems.replace("[ORGANIZATION_UNIT]", dto.organizationUnitId)
			};
			return $http(req);
		};

		const _updateClientExternalSystem = function (dto) {
			const req = {
				method: "put",
				data: dto,
				url:
					Vgr.constants.coreHostUrl +
					Vgr.resources.core.externalSystems.replace("[ORGANIZATION_UNIT]", dto.organizationUnitId) +
					dto.externalSystemId
			};
			return $http(req);
		};

		const _deleteClientExternalSystem = function (dto) {
			const req = {
				method: "delete",
				url:
					Vgr.constants.coreHostUrl +
					Vgr.resources.core.externalSystems.replace("[ORGANIZATION_UNIT]", dto.UnitId) +
					dto.ExternalSystemId
			};
			return $http(req);
		};

		const _listClientUserExternalSystems = function (dto) {
			const req = {
				method: "get",
				url:
					Vgr.constants.coreHostUrl +
					Vgr.resources.core.externalSystems.replace("[ORGANIZATION_UNIT]", dto.UnitId) +
					dto.externalSystemId +
					"/users"
			};
			return $http(req);
		};

		const _createClientUserExternalSystems = function (dto) {
			const req = {
				method: "post",
				data: dto.model,
				url:
					Vgr.constants.coreHostUrl +
					Vgr.resources.core.externalSystems.replace("[ORGANIZATION_UNIT]", dto.model.UnitId) +
					dto.model.ExternalSystemId +
					"/users"
			};
			return $http(req);
		};

		const _updateClientUserExternalSystems = function (dto) {
			const req = {
				method: "put",
				data: dto.model,
				url:
					Vgr.constants.coreHostUrl +
					Vgr.resources.core.externalSystems.replace("[ORGANIZATION_UNIT]", dto.model.UnitId) +
					dto.model.ExternalSystemId +
					"/users/" +
					dto.model.UserCode
			};
			return $http(req);
		};

		const _deleteClientUserExternalSystems = function (dto) {
			const req = {
				method: "delete",
				url:
					Vgr.constants.coreHostUrl +
					Vgr.resources.core.externalSystems.replace("[ORGANIZATION_UNIT]", dto.UnitId) +
					dto.externalSystemId +
					"/users/" +
					dto.userCode
			};
			return $http(req);
		};

		return {
			createClientExternalSystem: _createClientExternalSystem,
			updateClientExternalSystem: _updateClientExternalSystem,
			deleteClientExternalSystem: _deleteClientExternalSystem,

			listClientUserExternalSystems: _listClientUserExternalSystems,
			createClientUserExternalSystems: _createClientUserExternalSystems,
			updateClientUserExternalSystems: _updateClientUserExternalSystems,
			deleteClientUserExternalSystems: _deleteClientUserExternalSystems
		};
	}
]);
